export const ownershipMarkerPrefix = 'OwnerMark___' as const;
